import { cn } from "@/lib/utils";
import { Thetis } from "@patient-watch/icons";

interface AuthBrandProps {
    className?: string;
}

/** Centered logo and wordmark above the auth card. */
export function AuthBrand({ className }: AuthBrandProps) {
    return (
        <div className={cn("flex flex-col items-center gap-2", className)}>
            <span className="[&_svg]:w-9 [&_svg]:h-9 text-foreground">
                <Thetis />
            </span>
            <span className="font-semibold text-foreground text-sm tracking-tight">Patient Watch</span>
        </div>
    );
}
